import React from 'react';
import { Button } from 'antd';
import { LockOutlined, LoginOutlined } from '@ant-design/icons';

export const openLoginModal = () => {
  window.dispatchEvent(new CustomEvent('open-login-modal'));
};

export const openRegisterModal = () => {
  window.dispatchEvent(new CustomEvent('open-register-modal'));
};

/**
 * Full-bleed auth gate shown when user is logged out.
 * @param {{ title?: string, subtitle?: string, compact?: boolean }} props
 */
const LoginRequired = ({
  title = 'Prístup len pre prihlásených',
  subtitle = 'Prihláste sa firemným e-mailom a heslom, aby ste videli požiadavky a mohli s nimi pracovať.',
  compact = false,
}) => (
  <div className={`login-required${compact ? ' login-required--compact' : ''}`} role="status">
    <div className="login-required-bg" aria-hidden>
      <span className="login-required-orb login-required-orb--a" />
      <span className="login-required-orb login-required-orb--b" />
      <span className="login-required-grid" />
    </div>

    <div className="login-required-card">
      <div className="login-required-lock login-required-anim" style={{ '--d': '0ms' }} aria-hidden>
        <span className="login-required-ring" />
        <span className="login-required-ring login-required-ring--delay" />
        <span className="login-required-lock-core">
          <LockOutlined />
        </span>
      </div>

      <h2 className="login-required-title login-required-anim" style={{ '--d': '80ms' }}>
        {title}
      </h2>
      <p className="login-required-sub login-required-anim" style={{ '--d': '140ms' }}>
        {subtitle}
      </p>

      <div className="login-required-actions login-required-anim" style={{ '--d': '200ms' }}>
        <Button
          type="primary"
          size="large"
          icon={<LoginOutlined />}
          className="login-required-cta"
          onClick={openLoginModal}
        >
          Prihlásiť sa
        </Button>
        <button type="button" className="login-required-link" onClick={openRegisterModal}>
          Nemáte účet? Požiadať o registráciu
        </button>
      </div>
    </div>
  </div>
);

export default LoginRequired;
